module.exports = __webpack_public_path__ + "img/BOR_website_mockup.361ac52e.jpg";